import Categories from './Categories';

export default Categories;


// WEBPACK FOOTER //
// ./src/components/Query/Categories/index.tsx